import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeCurrency',
})
export class LocaleCurrencyPipe implements PipeTransform {
  transform(value: number, currency?: string): string {
    const locale = currency === 'MYR' ? 'ms-MY' : 'ID-id';
    return value?.toLocaleString(locale);
  }
}
